export default function GetDonorID(donorId: string, mockDonorId: string, unmaskDonorId: number): string {
  if (unmaskDonorId > 0) {
    return mockDonorId
  }
  return donorId
}
export function GetDonorIDTitle(donorId: string, mockDonorId: string, unmaskDonorId: number): string {
  if (unmaskDonorId > 0) {
    return mockDonorId
  }
  return donorId
}
